import React from 'react';
import PropTypes from 'prop-types';
import GroupsTableRow from '../GroupsTableRow';

const GroupsTable = ({ groups = [], setGroups }) => {

  const drawGroupRows = () => (
    groups.map((group) => (
      <GroupsTableRow
        key={group.id}
        group={group}
        groups={groups}
        setGroups={setGroups}
      />
    ))
  );

  return (
    <table className="table is-fullwidth is-narrow">
      <thead>
        <tr>
          <th>Name</th>
          <th>Bot</th>
          <th>Whitelist</th>
          <th>Blacklist</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {drawGroupRows()}
      </tbody>
    </table>
  );
};

GroupsTable.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    isBot: PropTypes.bool,
    isWhitelist: PropTypes.bool,
    isBlacklist: PropTypes.bool,
  })),
  setGroups: PropTypes.func
};

export default GroupsTable;
